// 教材征订统计模块
const state = {
  // 教材征订统计
  textbookStatistics: {
    period: 'quarter', // 只显示最新季次
    totalOrders: 0,
    totalAmount2025: 0,
    autumnAmount25: 0,
    // 新增同比字段
    totalAmount2025Tb: 0,
    autumnAmount25Tb: 0,
    // 动态label
    totalAmountLabel: '总码洋',
    autumnAmountLabel: '总码洋'
  }
}

const mutations = {
  // 设置教材征订统计
  SET_TEXTBOOK_STATISTICS(state, data) {
    state.textbookStatistics = data
  },
  // 重置教材征订统计
  RESET_TEXTBOOK(state) {
    state.textbookStatistics = {
      period: 'quarter',
      totalOrders: 0,
      totalAmount2025: 0,
      autumnAmount25: 0,
      totalAmount2025Tb: 0,
      autumnAmount25Tb: 0,
      totalAmountLabel: '总码洋',
      autumnAmountLabel: '总码洋'
    }
  }
}

const actions = {
  // 获取教材征订统计（支持静默刷新，优先使用大屏数据 jczhengding_* 字段派生）
  async fetchTextbookStatistics({ commit, rootState }, period = null) {
    try {
      // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
      const currentPeriod = period || state.textbookStatistics.period || 'quarter'
      
      const big = rootState.screen.screenData || {}
      const safeNum = (v) => {
        const n = Number(v)
        return isNaN(n) ? 0 : n
      }
      // 周期到字段的映射（订单数）
      const mapOrdersKey = {
        recent7days: 'jczhengding_week_dingdan',
        month: 'jczhengding_yue_dingdan',
        halfyear: 'jczhengding_bannian_dingdan',
        quarter: 'jczhengding_ji_dingdan'
      }
      const ordersKey = mapOrdersKey[currentPeriod] || mapOrdersKey.quarter
      const totalOrders = safeNum(big[ordersKey])

      // 非周期字段：2025总码洋、25秋总码洋 - 适配新接口格式
      // 新接口返回格式: { "today_amount": "434022653.56", "tb": "-27.24" }
      const totalAmount2025Data = big['jczhengding_2025mayang']
      const autumnAmount25Data = big['jczhengding_25qiu']
      
      // 处理2025总码洋数据
      let totalAmount2025 = 0
      let totalAmount2025Tb = 0
      let totalAmountLabel = '总码洋'
      if (totalAmount2025Data && typeof totalAmount2025Data === 'object') {
        totalAmount2025 = safeNum(totalAmount2025Data.today_amount || totalAmount2025Data.amount)
        totalAmount2025Tb = safeNum(totalAmount2025Data.tb)
        if (totalAmount2025Data.name) {
          totalAmountLabel = String(totalAmount2025Data.name)
        }
      } else {
        totalAmount2025 = safeNum(totalAmount2025Data)
      }
      
      // 处理25秋总码洋数据
      let autumnAmount25 = 0
      let autumnAmount25Tb = 0
      let autumnAmountLabel = '总码洋'
      if (autumnAmount25Data && typeof autumnAmount25Data === 'object') {
        autumnAmount25 = safeNum(autumnAmount25Data.today_amount || autumnAmount25Data.amount)
        autumnAmount25Tb = safeNum(autumnAmount25Data.tb)
        if (autumnAmount25Data.name) {
          autumnAmountLabel = String(autumnAmount25Data.name)
        }
      } else {
        autumnAmount25 = safeNum(autumnAmount25Data)
      }

      const payload = {
        period: currentPeriod,
        totalOrders,
        totalAmount2025,
        autumnAmount25,
        // 新增同比字段
        totalAmount2025Tb,
        autumnAmount25Tb,
        totalAmountLabel,
        autumnAmountLabel
      }
      commit('SET_TEXTBOOK_STATISTICS', payload)
    } catch (error) {
      console.error('获取教材征订统计失败:', error)
      commit('SET_TEXTBOOK_STATISTICS', {
        period: currentPeriod,
        totalOrders: 0,
        totalAmount2025: 0,
        autumnAmount25: 0,
        // 新增同比字段默认值
        totalAmount2025Tb: 0,
        autumnAmount25Tb: 0,
        totalAmountLabel: '总码洋',
        autumnAmountLabel: '总码洋'
      })
    }
  }
}

const getters = {
  currentTextbookPeriod: state => state.textbookStatistics.period,
  textbookStatistics: state => state.textbookStatistics
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
